import React, { useState, useEffect, useRef } from 'react';
import './scss/services.scss';
import ButtonAesthetic from '../../../assets/scss/components/buttonaesthetic';
import emprendeImg from '../../../assets/images/landing/services/emprender2.jpg';
import asesoriasImg from '../../../assets/images/landing/services/asesor1.jpg';
import auditoriasImg from '../../../assets/images/landing/services/auditoria2.jpg';
import outsourcingImg from '../../../assets/images/landing/services/out2.jpg';

const serviceContent = {
  emprende: {
    title: 'Emprende',
    titleDescription: 'Primeros pasos de una Pyme', // Aquí puedes escribir el contenido
    description: `En BackApp te guiamos desde el inicio para formalizar tu negocio, asegurando que cumplas con todos los requisitos legales y tributarios desde el primer día. Nos encargamos de que puedas concentrarte en tu idea, mientras nosotros nos ocupamos del papeleo y la gestión pública.`,
    image: emprendeImg,
    items: [
      'Constitución de sociedad en 1 día con escritura pública',
      'Inicio de actividades en el SII y apertura de RUT',
      'Tramitación municipal para obtener patente comercial',
      'Recomendaciones sobre el tipo de empresa más adecuado',
      'Apoyo en la creación de cuenta bancaria empresa y firma digital'
    ]
  },
  outsourcing: {
    title: 'Outsourcing',
    titleDescription: 'Administrar nunca había sido tan fácil', // Aquí puedes escribir el contenido
    description: `Sabemos que administrar una empresa puede consumir demasiado tiempo. Por eso, te ofrecemos externalizar procesos clave de tu negocio para que puedas enfocarte en crecer. Nuestro equipo contable, tributario y administrativo opera como una extensión de tu empresa, con informes periódicos y procesos siempre al día.`,
    image: outsourcingImg,
    items: [
      'Contabilidad mensual y cierre anual',
      'Declaraciones F29, F22, retiros y sueldos',
      'Recursos Humanos: contratos, liquidaciones, cotizaciones',
      'Control administrativo y manejo de flujo de caja',
      'Informes financieros y gestión de KPI contables'
    ]
  },
  asesorias: {
    title: 'Asesorías',
    titleDescription: 'Asesoría personalizada para tu negocio', // Aquí puedes escribir el contenido
    description: `En un entorno normativo cambiante, contar con asesoría especializada es clave. Te acompañamos para que cumplas con tus obligaciones laborales, tributarias y societarias sin errores ni multas. Diseñamos planes de acción personalizados y respondemos ante cualquier fiscalización.`,
    image: asesoriasImg,
    items: [
      'Cumplimiento laboral: contratos, descansos, jornadas',
      'Cumplimiento tributario y planificación fiscal inteligente',
      'Redacción y actualización de actas, poderes y escrituras',
      'Análisis legal de riesgos y oportunidades de mejora',
      'Soporte directo ante SII y Dirección del Trabajo'
    ]
  },
  auditorias: {
    title: 'Auditorías',
    titleDescription: 'Descubre cómo está tu empresa hoy', // Aquí puedes escribir el contenido
    description: `La transparencia y el control interno no son un lujo, son una necesidad. Nuestras auditorías te ofrecen una radiografía clara de tu empresa, detectando fallas, oportunidades y garantizando que todo esté en regla. Ya sea para inversionistas, bancos o gestión interna, te entregamos confianza con evidencia.`,
    image: auditoriasImg,
    items: [
      'Auditoría tributaria (F22, F29, boletas y libros contables)',
      'Auditoría laboral y de remuneraciones',
      'Análisis de estados financieros y sus respaldos',
      'Control interno y procedimientos administrativos',
      'Supervisión general de cumplimiento legal y societario'
    ]
  }
};

const Services = () => {
  const keys = Object.keys(serviceContent);
  const [activeService, setActiveService] = useState(keys[0]);
  const intervalRef = useRef(null);

  // Autoplay: cambia cada 2s
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setActiveService((prev) => {
        const currentIndex = keys.indexOf(prev);
        const nextIndex = (currentIndex + 1) % keys.length;
        return keys[nextIndex];
      });
    }, 2000);
    return () => clearInterval(intervalRef.current);
  }, []);

  // Click manual que reinicia el ciclo
  const handleClick = (key) => {
    clearInterval(intervalRef.current);
    setActiveService(key);
    intervalRef.current = setInterval(() => {
      setActiveService((prev) => {
        const currentIndex = keys.indexOf(prev);
        const nextIndex = (currentIndex + 1) % keys.length;
        return keys[nextIndex];
      });
    }, 2000);
  };

  return (
    <section id="services" className="services-section">
      <div className="services-intro">
        <h2>
          <span className="highlight">BackApp</span> <span className="tagline">Service</span>
        </h2>
        <p>
          En BackApp, ofrecemos soluciones personalizadas que se adaptan a cada etapa de tu negocio.
          Nuestro enfoque está centrado en automatizar procesos, reducir tu carga administrativa y brindarte
          el respaldo necesario para que te enfoques en crecer.
        </p>
        <p>Estos son nuestros principales servicios:</p>

        {/* Mueve los botones aquí */}
        <div className="tabs-container full-width">
          {keys.map((key) => (
            <ButtonAesthetic
              key={key}
              text={serviceContent[key].title}
              href="#services"
              onClick={() => handleClick(key)}
              outline={activeService !== key}
            />
          ))}
        </div>
      </div>

      <div className="services-content">
        {/* Nuevo componente horizontal agregado */}
        <div className="service-card-horizontal">
          <div className="service-left">
            <p className="service-subtitle"><strong>{serviceContent[activeService].titleDescription}</strong></p>
            <p className="service-description">{serviceContent[activeService].description}</p>
            <h3>Incluye:</h3>
            <ul>
              {serviceContent[activeService].items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="service-right">
            <img
              src={serviceContent[activeService].image}
              alt={serviceContent[activeService].title}
              className="service-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
